module.exports = __webpack_public_path__ + "static/media/2.4007b1e1.jpg";